import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { environment } from '@environments/environment';
import { UserFacade } from '@library/store/user/user.facade';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  get token(): string {
    return this.cookieService.get(`${environment.cookiePrefix}access_token`);
  }

  currentUser = toSignal(this.userFacade.currentUser$);
  tokenVerified = signal(false);
  loggedIn = signal(false);

  constructor(
    private readonly userFacade: UserFacade,
    private readonly httpClient: HttpClient,
    private readonly cookieService: CookieService,
  ) {}

  async assertToken(): Promise<void> {
    if (!this.token) {
      this.loggedIn.set(false);
    }
    else {
      try {
        await firstValueFrom(this.httpClient.get<{status: number}>(`${environment.apiUrl}asserttoken`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        }));
        this.loggedIn.set(true);
      }
      catch {
        this.loggedIn.set(false);
      }
    }

    this.tokenVerified.set(true);
  }
}
